import React from 'react'
import Login from '../components/Login';
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function LoginPage() {
    return (
        <>
            <Navbar />
            <Login />
            <Footer />
        </>
    )
}

export default LoginPage